module.exports = __webpack_public_path__ + "img/slide_5.fa59cebb.jpg";